// import { authRoles } from 'app/auth/authRoles';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const Analytics2 = Loadable(lazy(() => import('./Analytics2')));
const DriverOnlineDoughnutChart = Loadable(lazy(() => import('./DriverOnlineDoughnutChart')));
const DriverRegisteredDoughnutChart = Loadable(lazy(() => import('./DriverRegisteredDoughnutChart')));
const DriverWithVehicleDoughnutChart = Loadable(lazy(() => import('./DriverWithVehicleDoughnutChart')));
const PrimaryDoughnutChart = Loadable(lazy(() => import('./PrimaryDoughnutChart')));
const SOSReportLineChart = Loadable(lazy(() => import('./SOSReportLineChart')));
const SchoolDoughnutChart = Loadable(lazy(() => import('./SchoolDoughnutChart')));
const SecondaryDoughnutChart = Loadable(lazy(() => import('./SecondaryDoughnutChart')));
const VehiclewithStudentsDoughnutChart = Loadable(lazy(() => import('./VehiclewithStudentsDoughnutChart')));
const StudentAttendanceBarChart = Loadable(lazy(() => import('./StudentAttendanceBarChart')));

export const dashboardRoutes = [
  { path: '/dashboard', element: <Analytics2 /> },
  { path: '/dashboard', element: <DriverOnlineDoughnutChart /> },
  { path: '/dashboard', element: <DriverRegisteredDoughnutChart /> },
  { path: '/dashboard', element: <DriverWithVehicleDoughnutChart /> },
  { path: '/dashboard', element: <PrimaryDoughnutChart /> },
  { path: '/dashboard', element: <SOSReportLineChart /> },
  { path: '/dashboard', element: <SchoolDoughnutChart /> },
  { path: '/dashboard', element: <SecondaryDoughnutChart /> },
  { path: '/dashboard', element: <VehiclewithStudentsDoughnutChart /> },
  { path: '/dashboard', element: <StudentAttendanceBarChart /> },
];
